import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useAdminService } from '~/services';

interface BannerRemoveProps {
    bannerId: number;
    children: string | string[] | JSX.Element;
}
export function BannerRemove({ bannerId, children }: BannerRemoveProps) {
    const { removeBanner } = useAdminService();
    const [removing, setRemoving] = React.useState(false);

    async function handleRemoveBanner() {
        try {
            setRemoving(true);
            await removeBanner(bannerId);
        } catch (e) {
            setRemoving(false);
        }
    }

    return (
        <button
            className="btn btn-danger me-auto"
            disabled={removing}
            onClick={handleRemoveBanner}
            type="button"
        >
            {children}
            {removing && <Spinner animation="border" role="status" size="sm" className="ms-1" />}
        </button>
    );
}
